<script lang="ts">
import i3pSubComponent from '../I3pSubComponent.vue'
import { I3pEventsEnum } from '../../../types/I3pEvents.enum'
import { FilterService } from '../../../services/filter.service'

export default {
    name: 'ListPanel',
    extends: i3pSubComponent,
    props: {},
    data() {
        return {
            list: {},
            loadingList: false,
        }
    },
    computed: {
        editMode() {
            return this.i3pService.editMode
        },
        translationName() {
            return this.list?.model?.translationKey
        },
        filters() {
            return this.i3pService.getAvailableFilters() || []
        },
    },
    mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.indexDataUpdating, () => {
                this.loadingList = true
            })

        this.i3pService.emitter
            .on(I3pEventsEnum.indexDataUpdated, (event: { indexData: any[] }) => {
                this.loadingList = false
                this.list = { ...event.indexData, model: this.i3pService.getModel() }

                // REFRESH PAGINATION IF CURRENT PAGE HAS NO ELEMENTS IF WE CHANGE SIZE ON LAST PAGE
                if (this.i3pService.getPagination().number > this.list.meta.last_page) {
                    this.i3pService?.setPagination({ number: this.list.meta.last_page, size: this.list.meta.per_page })
                    this.i3pService.loadData()
                }
            })
    },
    methods: {
        showEntity(k) {
            this.i3pService.showEntity(k).then()
        },
        editEntity(k) {
            this.i3pService.showEntity(k).then(() => {
                this.i3pService.setEditMode(true)
            })
        },
        deleteEntity(k) {
            const nextKey = this.i3pService.getNextKey() // get next key before deleting
            this.i3pService.showEntity(k).then((entity) => {
                if (!entity) {
                    if (k !== this.i3pService.currentEntityK) {
                        console.warn(`entity [k: ${k}] not found!`)
                        return
                    }

                    entity = this.i3pService.currentEntity
                }
                this.i3pService.deleteEntity(entity).then(() => {
                    const previousKey = this.i3pService.getPreviousKey()
                    if (previousKey) {
                        this.showEntity(previousKey)
                    }
                    else {
                        if (nextKey) {
                            this.showEntity(nextKey)
                        }
                    }
                })
            })
        },
        setQuery(overrideQuery: object) {
            const filterService = new FilterService(this.list.meta)
            const hiddenFiltersQuery = filterService.getHiddenFiltersQuery(this.i3pService.getHiddenFilters())

            if (overrideQuery) {
                this.i3pService.setQuery({ ...overrideQuery, ...hiddenFiltersQuery })
            }
            else if (this.$refs.filters) {
                this.i3pService.setQuery({ ...this.$refs.filters.query, ...hiddenFiltersQuery })
            }
            this.i3pService.loadData(true).then()
        },
    },
}
</script>
